<template>
  <div>
    <!-- 视频、图片 -->
    <q-dialog
      :visible.sync="dialogVisible"
      :title="detailData.title"
      width="700px"
      :innerHeight="520"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
      :showFooter="false"
      v-esc-close
    > 
      <div class="pic-wrap">
        <el-carousel
          height="500px"
          arrow="always"
          :autoplay="false"
          trigger="click"
        >
          <el-carousel-item v-for="item in detailData.pictures" :key="item">
            <el-image :src="item" fit="contain" class="pic-item"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible', 'data'],
  data() {
    return {
      detailData: {},
      dialogVisible: false
    }
  },
  mounted() {
    let video = "";
    const pictures = [];

    this.data.imageList.forEach((item) => {
      pictures.push(item);
    });

    this.detailData = {
      video,
      pictures,
      title: "图片",
    };
    this.dialogVisible = this.visible;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.updateVal();
    }
  }
}
</script>

<style lang="stylus" scoped>
  .pic-item
    width 100%
    height 500px
</style>